import { Star, Quote } from "lucide-react";
import { useLang } from "@/context/LanguageContext";

export const Testimonials = () => {
  const { t } = useLang();
  return (
    <section className="py-20 md:py-32 bg-sand-surface" data-testid="testimonials-section">
      <div className="px-6 md:px-12 lg:px-20 mx-auto max-w-7xl">
        <div className="max-w-2xl mb-16">
          <p className="font-body text-xs tracking-[0.25em] uppercase text-teal font-bold mb-4">{t.testimonials.overline}</p>
          <h2 className="font-heading text-3xl sm:text-4xl lg:text-5xl font-semibold text-jungle">{t.testimonials.title}</h2>
        </div>
        <div className="grid md:grid-cols-3 gap-6">
          {t.testimonials.items.map((item, i) => (
            <div key={i} data-testid={`testimonial-${i}`} className="bg-white border border-border p-8 hover:-translate-y-1 hover:shadow-lg transition-all duration-300">
              <Quote size={28} className="text-teal/40 mb-4" />
              <div className="flex gap-1 mb-4">
                {[...Array(5)].map((_, s) => (
                  <Star key={s} size={15} className="text-teal fill-teal" />
                ))}
              </div>
              <p className="font-body text-sm text-jungle-light/85 leading-relaxed mb-6 italic">"{item.text}"</p>
              <p className="font-heading text-lg font-semibold text-jungle">{item.name}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
